module.exports = __webpack_public_path__ + "static/media/prIcon.c4dee9c8.svg";